export default ({ savedItems: { sortFocus } }) => !!sortFocus;
